module.exports = __webpack_public_path__ + "static/img/aRZ_pic10.51c1193.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aRZ_pic10.jpg
// module id = sUAl
// module chunks = 5